import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=25d4dc13"
import script from "./QuestionAdd.vue?vue&type=script&lang=js"
export * from "./QuestionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports